/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Day_Spare_Opossum_CommendInputs */

const fr_day_spare_opossum_commend = /** @type {(inputs: Day_Spare_Opossum_CommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice de référence pour RM`)
};

/**

* @param {Day_Spare_Opossum_CommendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const day_spare_opossum_commend = /** @type {((inputs?: Day_Spare_Opossum_CommendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Day_Spare_Opossum_CommendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_day_spare_opossum_commend(inputs)
});